import {styled} from "@mui/material/styles";
import { Card } from "@mui/material";

export const Content = styled(Card)(() => ({
    marginTop: '10px',
    padding: 20,
    borderRadius: '8px',
    boxShadow: 'rgba(99, 99, 99, 0.2) 0px 2px 3px 0px',
}))
